interface ContentEditableStyleProps {
  isInvalid?: boolean;
  isDisabled?: boolean;
  placeholder?: string;
}

export const getContentEditableStyle = ({
  isInvalid,
  placeholder,
  isDisabled,
}: ContentEditableStyleProps) => ({
  whiteSpace: 'pre-wrap',
  width: '100%',
  minWidth: '0px',
  outline: '2px solid transparent',
  outlineOffset: '2px',
  position: 'relative',
  appearance: 'textarea',
  py: 3,
  px: 3,
  fontSize: 'sm',
  lineHeight: 'short',
  verticalAlign: 'top',
  borderRadius: 4,
  border: '1px solid',
  borderColor: isInvalid ? 'R.80' : 'M.30',
  background: 'surface2',
  resize: 'none',
  wordBreak: 'break-word',
  maxHeight: '144px',
  height: 'full',
  transitionDuration: 'normal',
  transitionProperty: 'common',
  overflow: 'auto',
  _focus: {
    boxShadow: '0px 0px 8px 0px var(--chakra-colors-B-50)',
  },
  '::before': {
    cursor: isDisabled ? 'default' : 'text',
    content: `attr(placeholder)`,
    color: 'M.50',
  },
  ':empty:focus::before': {
    content: `'${placeholder}'`,
  },
  ':not(:empty)::before': {
    content: "''",
  },
});
